import { isTrue } from 'src/utils/helper';
import { APIS, METHOD_DELETE } from '../constants/apis';
import { STRAPI_URL } from '../constants/url';
import { PostRecord } from './PostRecord';

export default async function DeleteRecord(api: string, id: number, sendPush: boolean = true) {
	let response = await fetch(`${STRAPI_URL}/api/${api}/${id}`, {
		method: METHOD_DELETE,
		credentials: 'include',
	});

	if (!response.ok) {
		throw new Error(await response.text());
	}
	if (isTrue(sendPush)) {
		const entries = [
			{
				api: api,
				id: id,
				method: 'delete',
			},
		];

		await PostRecord(APIS.PushNotificaiton, { data: { entities: entries } });
	}
	const responseData = await response.json();
	return responseData;
}
